
export class PaymentMethod {
  type: string | undefined;
  details: any | undefined;
  updateLink: string | undefined;


  constructor(payload?: any) {
    if (payload) {
      this.type = payload.type;
      this.details = payload?.details;
      this.updateLink = payload?.updateLink;
    }
  }

}
